import { State } from 'src/app/shared/constants';

export enum AddressType {
    Legal = 'Legal',
    Billing = 'Billing',
    Shipping = 'Shipping',
    Service = 'Service',
    Return = 'Return',
    Site = 'Site',
}

export interface ICustomerAddressFilterOptions {
    includeTypes?: AddressType[];
    excludeTypes?: AddressType[];
}

export enum Country {
    AT = 'AT',
    DE = 'DE',
    CH = 'CH',
    ES = 'ES',
}

export interface IBaseCustomerAddress {
    type: AddressType;
    name: string; // 1..128
    addressLine?: string | null; // <=128
    addressLine2?: string | null; // <=128
    postCode: string; // 1..16
    city: string; // 1..128
    region?: State | null; // <=92
    country: Country;
    notes?: string | null;
    nameAffix1?: string | null; // <=128
    nameAffix2?: string | null; // <=128
}

/** Live customer address (ClientAddress) — use `id` when selecting / submitting address ids. */
export interface ICustomerAddress extends IBaseCustomerAddress {
    id: string; // uuid
    version?: string | null; // opaque version token
}

/**
 * Immutable address snapshot embedded on orders, deliveries, invoices, etc.
 * `id` is the snapshot row id — not a ClientAddress id.
 * Use `clientAddressId` when matching or re-submitting a live customer address.
 */
export interface IAddressSnapshot {
    id: string; // uuid — snapshot id
    clientAddressId: string | null; // uuid of originating ClientAddress, if it still exists
    name: string | null;
    nameAffix1?: string | null;
    nameAffix2?: string | null;
    addressLine?: string | null;
    addressLine2?: string | null;
    postCode: string | null;
    city: string | null;
    region?: string | null;
    country: Country;
    notes?: string | null;
}
